export default "__VITE_ASSET__DLNRttA8__"